import React from 'react'
import { Menu } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import { makeEnumReadable } from '../util/string'

function classNames(...classes: string[]): string {
  return classes.filter(Boolean).join(' ')
}

export interface ActionMenuProps {
  handleChange: (value?: string) => Promise<void>
  options?: Array<{ label?: string; value: string }>
  label?: string
  variant?: 'default' | 'button'
}

const buttonClassNames = {
  default:
    'inline-flex items-center justify-center rounded-md border border-slate-300 dark:border-slate-700 shadow-sm px-3 py-2 bg-white dark:bg-slate-800 text-sm font-medium text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-100 dark:focus:ring-offset-slate-800 focus:ring-indigo-500',
  button:
    'inline-flex items-center justify-center rounded-md border border-transparent px-3 py-2 text-sm font-medium text-indigo-600 dark:text-indigo-50 bg-indigo-100 dark:bg-indigo-900 hover:bg-indigo-200 dark:hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-slate-100 dark:focus:ring-offset-slate-800 focus:ring-indigo-500',
}

export const ActionMenu: React.FC<ActionMenuProps> = (props) => {
  const { handleChange, options, label = 'Actions', variant = 'default' } = props

  if (options === undefined || options?.length === 0) {
    return null
  }

  return (
    <Menu as="div" className="relative inline-block text-left">
      <Menu.Button className={buttonClassNames[variant]}>
        {label}
        <ChevronDownIcon className="ml-2 h-4 w-4" aria-hidden="true" />
      </Menu.Button>
      <Menu.Items
        anchor={{ to: 'bottom end', gap: 4 }}
        portal
        modal={false}
        className="z-[9999] min-w-[140px] rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none dark:bg-slate-800"
      >
        <div className="py-1">
          {options.map((status, index) => (
            <Menu.Item key={`menu-${index}`}>
              {({ active }) => (
                <button
                  type="button"
                  onClick={() => {
                    void handleChange(status?.value)
                  }}
                  className={classNames(
                    'w-full text-left',
                    active
                      ? 'bg-slate-100 dark:bg-slate-700 text-slate-900 dark:text-slate-100'
                      : 'text-slate-700 dark:text-slate-300',
                    'block px-4 py-2 text-sm'
                  )}
                >
                  {status?.label ?? makeEnumReadable(status?.value)}
                </button>
              )}
            </Menu.Item>
          ))}
        </div>
      </Menu.Items>
    </Menu>
  )
}

export default ActionMenu
